import type { PersonalDataTranslations } from './personalData.translation.pl.ts';

export const personalDataTranslations: PersonalDataTranslations = {
  heading: 'Tell us a bit about yourself',
  areasHeading: 'Areas I want to apply to',
  areasDescription: 'Choose up to 3 areas and set their priorities',
  checkboxText: 'I declare that I have read the terms and conditions and accept them.',
  areasSelection: {
    instruction: 'Choose the areas that interest you most:',
    proceed: 'Go to setting priorities',
  },
  areasPrioritization: {
    instruction: 'Drag the areas to set their order (1 = highest priority):',
    backToSelection: '← Back to selection',
  },
  fields: {
    firstName: 'First name',
    lastName: 'Last name',
    phoneNumber: 'Phone number (digits only)',
    fieldOfStudy: 'Field of study',
    graduationYear: { label: 'Year of study / graduate', placeholder: 'Completed year of study' },
    studentStatus: 'Status',
    universityName: 'University name',
    location: { label: 'City', placeholder: 'Location where you want to do your internship' },
    typeOfStudy: 'Type of studies',
    aboutYourself: {
      label: 'Tell us something about yourself',
      placeholder:
        'This space is yours - tell us what motivates you, show off your achievements or the projects you have taken part in',
    },
    areaDescription: {
      label: 'Business area',
      placeholder: 'Which area is closest to you and why? Let us know!',
    },
    isUnder30: 'I confirm that I am under 30 years old',
    linkedinUrl: 'LinkedIn link',
    githubUrl: 'GitHub or portfolio link',
    notRequired: 'Optional',
    required: 'required field',
  },
  graduationYearOptions: {
    placeholder: 'Year of study / graduate',
    '2': 'Year 2',
    '3': 'Year 3',
    '4': 'Year 4',
    '5': 'Year 5',
    '6': 'Graduate under 30',
  },
  button: {
    back: 'Back',
    next: 'Next',
  },
  errors: {
    phoneNumberMin: 'The phone number must have at least 9 digits',
  },
  dropdown: {
    search: 'Search...',
    noResults: 'No results',
  },
  university: {
    addCustom: 'Add your own:',
    selectFromList: 'Select from the list above',
  },
};
